import { Button } from '@platform/components';
import ContentPanel from './ContentPanel';
import { H1, Description } from './utils';
import cx from 'classix';

const HeroHeaderSection = ({
  title,
  description,
  mobileImage,
  desktopImage,
  signUpUrl,
  useDesktopImagePadding,
}: {
  title: string;
  description: string;
  mobileImage: string;
  desktopImage: string;
  signUpUrl: string;
  // A hacky way to add extra padding to the desktop image used on the /professionals page
  // to fit the mocks
  useDesktopImagePadding?: boolean;
}) => {
  return (
    <ContentPanel noBottomPadding>
      <div className='lg:flex lg:-mt-20 lg:min-h-[720px] border-b-1 border-b-gray-100'>
        <div className='z-10 lg:flex lg:flex-col lg:justify-center lg:w-[544px]'>
          <H1>{title}</H1>
          <div className='lg:w-[480px]'>
            <Description>{description}</Description>
          </div>
          <div className='lg:hidden mb-8'>
            <Button variant='primary' size='xl' href={signUpUrl}>
              Get Started
            </Button>
          </div>
          <div className='hidden lg:block'>
            {/* TODO: This button should be 60px on desktop, but our component library doesn't support dynamic heights based on media queries */}
            {/* TODO: Find a better way to set the width on this */}
            <div className='w-[149px]'>
              <Button variant='primary' size='xl' href={signUpUrl}>
                Get Started
              </Button>
            </div>
          </div>
        </div>
        <img className='lg:hidden mt-8 max-w-full' src={mobileImage} />
        <img
          className={cx(
            'absolute top-0 z-0 -right-8 hidden lg:block h-[720px] aspect-auto',
            useDesktopImagePadding && 'pt-6 pr-8',
          )}
          src={desktopImage}
        />
      </div>
    </ContentPanel>
  );
};

export default HeroHeaderSection;
